import * as materials from "@lts/materials/legacy/legacy-terrain";
export { materials };
export default materials;
